import * as React from 'react'

import { PartialArticle } from '@doist/help-center-utils'
import { Box, Link, Text } from '@doist/marketist'

import { useTranslation } from 'next-i18next'

import css from './RelatedArticles.module.css'

export type RelatedArticleProps = {
    articles: PartialArticle[]
}

export function RelatedArticles({ articles }: RelatedArticleProps) {
    const { t } = useTranslation('helpcenter')

    return (
        <Box className={css.relatedArticles}>
            <Text tag="h3" size="minor-xs" style={{ textTransform: 'uppercase' }}>
                {t('article.related')}
            </Text>
            <ul>
                {articles.map((r) => (
                    <li key={r.id}>
                        <Link size="body-sm" icon="arrow" href={r.href}>
                            {r.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </Box>
    )
}
